import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import useDimensions from "react-cool-dimensions";

const ModelNavWrapper = styled.div`
    margin: 1rem -1rem 0 -1rem;
    border-bottom: 1px solid ${(props) => props.theme.BorderColor};
    border-top: 1px solid ${(props) => props.theme.BorderColor};
    padding: 0.5rem 0 0 0;

    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: white;

    .scroller-container {
        width: auto;
        overflow-x: auto;
        overflow-y: hidden;

        .scroller-panel {
            padding: 0.25rem 0 1rem 1.15rem;
            display: inline-flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            align-items: center;
            gap: 0;

            .playlist-link-wrapper {
                display: flex;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;

                &:last-child {
                    padding-right: 1rem;
                }

                .playlist-link {
                    padding: 0;

                    font-size: 1.1rem;
                    /* text-transform: capitalize; */
                    white-space: nowrap;

                    &.active {
                        font-weight: 500;
                    }
                }

                .ant-divider.ant-divider-vertical {
                    height: 1.4em;
                    top: 0;
                    border-left: 1px solid rgba(0, 0, 0, 0.1);
                    margin: 0 0.5rem;
                }
            }

            .scroller-spacer {
                width: 4rem;
            }
        }
    }

    .scroller-button {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #fff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        border-left: ${(props) => props.theme.DefaultBorder};
        font-size: 1.5rem;
    }
`;

const PlaylistsNavMobileNoScroll = ({ model, compact, activePlaylist, setActivePlaylist }) => {
    const [isScrollerVisible, setIsScrollerVisible] = useState(false);

    const scrollerContainerRef = useRef();
    const { observe: observeContainer, width: scrollerContainerWidth } = useDimensions();

    const scrollerRef = useRef();
    const { observe: observeScroller, width: scrollerWidth } = useDimensions();

    useEffect(() => {
        setIsScrollerVisible(scrollerWidth > scrollerContainerWidth);
    }, [scrollerWidth, scrollerContainerWidth]);

    const scrollLeft = () => {
        scrollerContainerRef.current.scrollLeft += 100;
    };

    if (!model || !model.Playlists || !model.Playlists.length) {
        return null;
    }

    const onActivePlaylistChange = (index) => {
        //scrollIntoView the nav element
        if (index) {
            const selectedNavItem = document.getElementById(`nav-playlist-${index}`);
            //scrollIntoView the selected nav item
            selectedNavItem.scrollIntoView({ behavior: "smooth", inline: "center" });
        }
    };

    const handlePlaylistChange = (index) => {
        setActivePlaylist(index);
        onActivePlaylistChange(index);
    };

    return (
        <ModelNavWrapper
            //$empty={!hasMoreThanOnePlaylist()}
            $compact={compact}
            $isScrollerVisible={isScrollerVisible}
        >
            <div
                className="scroller-container"
                ref={(el) => {
                    observeContainer(el);
                    scrollerContainerRef.current = el;
                }}
            >
                <div
                    className="scroller-panel"
                    ref={(el) => {
                        observeScroller(el);
                        scrollerRef.current = el;
                    }}
                >
                    {model.Playlists.map((mp, index) => (
                        <div className="playlist-link-wrapper" key={index} id={`nav-playlist-${index}`}>
                            <div
                                className={`playlist-link ${activePlaylist === index ? "active" : ""}`}
                                onClick={() => handlePlaylistChange(index)}
                            >
                                {mp.Name}
                            </div>
                            {index < model.Playlists.length - 1 && <Divider type="vertical" />}
                        </div>
                    ))}
                    {isScrollerVisible && <div className="scroller-spacer"></div>}
                </div>
            </div>
            {isScrollerVisible && (
                <div className="scroller-button" onClick={scrollLeft}>
                    <FontAwesomeIcon icon={icon({ family: "sharp", style: "light", name: "chevron-right" })} />
                </div>
            )}
        </ModelNavWrapper>
    );
};

export default PlaylistsNavMobileNoScroll;
